import { client } from '../../../types/gen/client.gen'

/**
 * Konfigurace vygenerovaného API klienta. Aplikace nikdy nevolá fetch ručně -
 * veškerá komunikace se serverem jde přes funkce z ../../../types/gen.
 */
client.setConfig({
    baseUrl: '/api',
    credentials: 'same-origin',
    throwOnError: false,
})

export { client }
